import { Checkbox, CheckboxProps, FormControl, FormControlLabel, Typography } from '@mui/material'
import { RiskMinor } from '@shopify/polaris-icons'
import React, { ReactNode } from 'react'
import tw from 'twin.macro'

interface Props {
  name?: string
  label?: string | ReactNode
  value?: any
  error?: boolean
  helperText?: string | false
  disabled?: boolean
  onChange(e: React.ChangeEvent<any>): void
  inputProps?: CheckboxProps['inputProps'] & { 'data-testid'?: string }
}

export const BasicCheckbox = ({
  name,
  label,
  value,
  error,
  helperText,
  disabled,
  onChange,
  inputProps,
}: Props) => {
  const getColorStyle = () => {
    if (disabled) {
      return {
        container: tw`border-shades-200`,
        text: tw`text-shades-300`,
      }
    }

    if (error) {
      return {
        container: tw`border-critical-500`,
        text: tw`text-critical-500`,
      }
    }

    if (value) {
      return {
        container: tw`border-primary-500`,
        text: tw`text-primary-500`,
      }
    }

    return {
      container: tw`border-shades-300`,
      text: tw`text-shades-400`,
    }
  }

  return (
    <FormControl error={error} disabled={disabled}>
      <FormControlLabel
        css={[tw`w-full rounded-lg border border-solid ml-0 p-0.5`, getColorStyle().container]}
        control={
          <Checkbox
            name={name}
            checked={!!value}
            value={true}
            css={getColorStyle().text}
            onChange={onChange}
            disabled={disabled}
            inputProps={inputProps}
          />
        }
        label={
          <Typography css={getColorStyle().text} variant="body1">
            {label}
          </Typography>
        }
        disabled={disabled}
      />
      {!!error && !!helperText && (
        <div css={tw`flex items-center gap-1 mt-2`}>
          <RiskMinor width={20} css={tw`fill-critical-500`} />
          <Typography variant="body2" css={tw`text-critical-500`}>
            {helperText}
          </Typography>
        </div>
      )}
    </FormControl>
  )
}
